// Create this new file: components/AnalyticsInjector.js
import { useEffect } from "react";

const AnalyticsInjector = () => {
    useEffect(() => {
        // Inject Google Analytics if IDs are provided
        const gtagId = process.env.REACT_APP_GTAG_ID;
        const gaId = process.env.REACT_APP_GA_ID;

        if (gtagId && gtagId !== "%REACT_APP_GTAG_ID%") {
            // Inject GTAG script
            const gtagScript = document.createElement("script");
            gtagScript.async = true;
            gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${gtagId}`;
            document.head.appendChild(gtagScript);

            // Inject GTAG config
            const gtagConfigScript = document.createElement("script");
            gtagConfigScript.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${gtagId}');
      `;
            document.head.appendChild(gtagConfigScript);
        }

        if (gaId && gaId !== "%REACT_APP_GA_ID%") {
            // Inject GA script
            const gaScript = document.createElement("script");
            gaScript.async = true;
            gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
            document.head.appendChild(gaScript);

            // Inject GA config
            const gaConfigScript = document.createElement("script");
            gaConfigScript.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${gaId}');
      `;
            document.head.appendChild(gaConfigScript);
        }

        // Inject structured data
        const structuredData = {
            "@context": "https://schema.org",
            "@type": "Organization",
            name:
                process.env.REACT_APP_COMPANY_NAME || process.env.REACT_APP_SITE_NAME,
            description: process.env.REACT_APP_SITE_DESCRIPTION,
            url: process.env.REACT_APP_SITE_URL,
            contactPoint: {
                "@type": "ContactPoint",
                telephone: process.env.REACT_APP_COMPANY_PHONE_NUMBER,
                contactType: "customer service",
            },
            address: {
                "@type": "PostalAddress",
                addressCountry: "CA",
            },
        };

        const structuredDataScript = document.getElementById("structured-data");
        if (structuredDataScript) {
            structuredDataScript.type = "application/ld+json";
            structuredDataScript.innerHTML = JSON.stringify(structuredData);
        }
    }, []);

    return null; // This component doesn't render anything
};

export default AnalyticsInjector;
